const Layout = () => import(/* webpackChunkName: "Layout" */ "../views/Layout.vue");

const InformationColumn = () => import(/* webpackChunkName: "Home" */ "../views/informationColumn/Index.vue");
export default [
  {
    path: "/information-column",
    name: "informationColumn",
    component: Layout,
    meta: {
      title: "信息专栏",
      // titleEn: "MEMBERSHIP HANDBOOK",
      titleEn: "Members Benefit",
    },
    children: [
      {
        path: "",
        component: InformationColumn,
      },
    ],
  },
];
